__turbopack_context__.v({
  "ribbon": "community-plus-ribbon-module-scss-module__hZfu2q__ribbon",
});
